import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';

import { Link } from 'react-router';
import Dropzone from 'react-dropzone';


class ImportRosterModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
    };
    this.onDropRoster = this.onDropRoster.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }
  onDropRoster(acceptedFiles) {
    this.setState({
      files: acceptedFiles,
    });
    this.props.importRoster(this.props.tourId, acceptedFiles);
    this.props.onClose();
  }
  handleCancel(event) {
    event.preventDefault();
    this.props.onClose();
  }
  render() {
    const modalLabel = 'Import Roster';
    return (
      <Modal show={this.props.show} onHide={this.props.onClose}>
        <Modal.Header closeButton>
          <Modal.Title>{ modalLabel }</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Dropzone
              ref={(node) => { this.dropzone = node; }}
              onDrop={this.onDropRoster}
            >
              <div>
                <div className="text-center">
                  Drop your roster spreadsheet here, or click to select files to upload.
                  <br /><i className="fa fa-file-excel-o fa-5x" aria-hidden="true" />
                </div>
              </div>
            </Dropzone>
            <Link to="/Example_Tour-Roster.xlsx" target="_blank">Download Template</Link>
          </div>
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    );
  }
}

ImportRosterModal.propTypes = {
  tourId: PropTypes.number.isRequired,
  show: PropTypes.bool.isRequired,
  importRoster: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default ImportRosterModal;



// WEBPACK FOOTER //
// src/routes/tours/components/ImportRosterModal.js